import React, { FC } from "react";
import { ColorType, LinkButton, Text } from "@ifgengineering/component-library";
import {
  WrapperWidth,
  ContentWrapper,
  PageWrapper,
  HeaderWrapper,
} from "./styled";

type Props = {
  children: React.ReactNode;
  background?: ColorType;
  title?: string;
  subtitle?: string;
  width?: WrapperWidth;
  onGoBack?: () => void;
  backButtonText?: string;
  padding?: string;
  hideContent?: boolean;
  /** Lets a child use position: sticky; off by default so other pages keep today's clipping. */
  allowStickyContent?: boolean;
};

const PageLayout: FC<Props> = ({
  children,
  background,
  title,
  subtitle,
  width = "NARROW",
  padding,
  onGoBack,
  backButtonText = "Back",
  hideContent,
  allowStickyContent = false,
}) => {
  return (
    <PageWrapper background={background} $allowSticky={allowStickyContent}>
      <ContentWrapper width={width} padding={padding}>
        {!hideContent && (
          <HeaderWrapper>
            {onGoBack && (
              <LinkButton
                testId="back-button"
                text={backButtonText}
                textSize="S18"
                textColor="BLUE600"
                icon="Left"
                iconSize={22}
                onClick={onGoBack}
              />
            )}
            <div>
              {title && (
                <Text type="H32" color={"SLATE900"} fontFamily="archiaregular">
                  {title}
                </Text>
              )}
              {subtitle && (
                <Text align="left" type="P18" color="SLATE900">
                  {subtitle}
                </Text>
              )}
            </div>
          </HeaderWrapper>
        )}
        {children}
      </ContentWrapper>
    </PageWrapper>
  );
};

export default PageLayout;
